import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {ProductParameterType} from './model';

export interface ProductParameterTypeState extends EntityState<ProductParameterType> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ProductParameterType' })
export class Store extends EntityStore<ProductParameterTypeState> {

  constructor() {
    super();
  }

}
